import styled from '@emotion/styled'

export const ButtonWrapper = styled.div`
  width: 160px;
`
